export default __webpack_public_path__ + "static/media/lobby-screen-1.af6efbc2.mp4";